import type { BeneficiaryWizardFormData } from "@/domain/validation/beneficiarySchemas";
import { splitRepresentativeName } from "@/domain/representative";

const optional = (value: string) => value.trim() || undefined;

const toEmployees = (value: string) => {
  const digits = value.replace(/\D/g, "");
  return digits === "" ? undefined : Number(digits);
};

export function buildBeneficiaryWizardRequest(values: BeneficiaryWizardFormData) {
  if (!values.companyType || !values.incentiveType) {
    throw new Error("The wizard submits only complete legal and fiscal data");
  }
  const { firstName, lastName } = splitRepresentativeName(values.representative.fullName);
  const iban = values.iban.trim();
  return {
    name: values.name.trim(),
    tax_id: values.taxId.trim(),
    company_type: values.companyType,
    incentive_type: values.incentiveType,
    main_activities: values.activities,
    constitution_date: optional(values.constitutionDate),
    business_purpose: optional(values.businessPurpose),
    cnae_code: optional(values.cnae),
    last_year_revenue: optional(values.revenue),
    employee_count: toEmployees(values.employees),
    address: optional(values.address),
    city: optional(values.city),
    postal_code: optional(values.postalCode),
    state: optional(values.province),
    country: optional(values.country),
    phone: optional(values.phone),
    email: optional(values.email),
    website: optional(values.website),
    legal_representative: {
      first_name: firstName,
      last_name: lastName,
      dni: values.representative.dni.trim(),
      position: values.representative.position,
      phone: values.representative.phone.trim(),
      email: values.representative.email.trim(),
    },
    banking_info: iban
      ? {
          bank_name: values.bankName.trim(),
          iban,
          swift: values.swift.trim(),
          certificate: null,
        }
      : undefined,
    documentation: {
      company_bylaws: null,
      legal_powers: null,
      cif_certificate: null,
      census_certificate: null,
    },
  };
}
